import {Component, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {formatDate} from '@angular/common';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DesbloqueoOrdenBalanzaCalidadService} from '../../services/desbloqueo-orden-balanza-calidad.service';
import {OrdenBalanzaService} from '../../services/orden-balanza.service';

@Component({
  selector: 'app-desbloqueo-orden-balanza-calidad',
  templateUrl: './desbloqueo-orden-balanza-calidad.component.html',
  styleUrls: ['./desbloqueo-orden-balanza-calidad.component.css']
})
export class DesbloqueoOrdenBalanzaCalidadComponent implements OnInit {

  public DAT_TITULOS: any = moduloGaritas.titulos.desbloqueoOrdenBalanzaCalidad;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_AG_GRID: any = moduloGaritas.agGrid;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs: any[] = [];
  public rowData: any[] = [];

  public isCreate: boolean = false;
  public tituloModal: string = '';
  public loading: boolean = false;
  public agregarForm = new FormGroup({
    ordenbalanza: new FormControl(null, [Validators.required, Validators.pattern(/^[0-9]*$/)]),
    proveedor: new FormControl(null, [Validators.required]),
    autoriza: new FormControl(null, [Validators.required]),
    material: new FormControl(null, [Validators.required]),
    difAcidez: new FormControl(null, [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,4})?$/)]),
    horaAuth: new FormControl(null, [Validators.required]),
    usuarioAutoriza: new FormControl(null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9/]+$/), Validators.maxLength(10)]),
    fechaAuth: new FormControl(null, [Validators.required]),
    usuarioCaptura: new FormControl(null),
    fechaHoraCaptura: new FormControl(null),
    difHumedadimp: new FormControl(null, [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,4})?$/)]),
    analista: new FormControl(null, [Validators.required, Validators.pattern(/^[A-Za-z ]*[A-Za-z][A-Za-z]*$/), Validators.maxLength(40)]),
    loteInspeccion: new FormControl(null, [Validators.required, Validators.pattern(/^[0-9]*$/), Validators.maxLength(38)]),
    tipo: new FormControl(null, [Validators.required, Validators.pattern(/^[0-9]*$/), Validators.maxLength(38)])
  });
  private isValidForm: boolean = false;
  private userName = localStorage.getItem('userName');
  private subscription = new Subscription();

  constructor(
    private _util: UtilsService,
    private desbloqueoOrdenBalanzaCalidadS: DesbloqueoOrdenBalanzaCalidadService,
    private ordenBalanzaService: OrdenBalanzaService
  ) {
  }

  ngOnInit() {
    this.girdComponent();
    this.obtenerTodo();
    this.subscription.add(
      this.agregarForm.get('ordenbalanza').valueChanges
        .pipe(debounceTime(1000))
        .subscribe(
          resp => {
            if (resp) {
              this.getOrdenBalanzaById(resp);
            }
          }
        )
    );
  }

  getOrdenBalanzaById(balanzaId: number) {
    this.subscription.add(
      this.ordenBalanzaService.obtenerPorId(balanzaId).subscribe(
        res => {
          if (res) {
            this.agregarForm.get('proveedor').setValue(res.proveedor);
            this.agregarForm.get('material').setValue(res.ordenCompra.mat);
            this.agregarForm.get('usuarioCaptura').setValue(res.idusuario);
            this.agregarForm.get('fechaHoraCaptura').setValue(
              formatDate(new Date(res.fechIn), 'dd-MM-yyyy HH:mm', 'en')
            );
            this.isValidForm = true;
          } else {
            this.agregarForm.get('proveedor').reset();
            this.agregarForm.get('material').reset();
            this.agregarForm.get('usuarioCaptura').reset();
            this.agregarForm.get('fechaHoraCaptura').reset();
            this._util.mensajeErroToast('No se encontró la orden de balanza.');
            this.isValidForm = false;
          }
        }
      )
    );
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Secuencial',
        field: 'id',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        headerName: 'Fecha',
        field: 'fechaAuth',
        sortable: true,
        filter: true,
        cellRenderer: (data) => {
          return data.value ? formatDate(new Date(data.value), 'dd-MM-yyyy HH:mm', 'en') : ''
        }
      },
      {
        headerName: 'Orden Balanza',
        field: 'ordenbalanza',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Usuario Autoriza',
        field: 'usuarioAutoriza',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Autorizado',
        field: 'autoriza',
        sortable: true,
        filter: true,
      },
    ];
  }

  obtenerTodo() {
    this.loading = true;
    this.subscription.add(
      this.desbloqueoOrdenBalanzaCalidadS.obtener().subscribe(
        (resp) => {
          this.rowData = resp;
          this.loading = false;
        },
        (error) => {
          this.rowData = [];
          this.loading = false;
        }
      )
    );
  }

  guardarCrearNueva() {
    if (this.agregarForm.invalid || !this.isValidForm) {
      this._util.mensajeErroToast('Orden de balanza inválida.');
      return;
    }

    this.loading = true;
    if (this.agregarForm.invalid) return;
    let data = this.agregarForm.getRawValue();
    data.fechaAuth = data.fechaAuth.split('-').reverse().join('-') + 'T' + data.horaAuth + ':00';

    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: `Desbloqueo orden: ${this.agregarForm.get('ordenbalanza').value}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.desbloqueoOrdenBalanzaCalidadS.crear(data),
      })
      .then(() => {
        this.obtenerTodo();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  nuevo() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.agregarForm.reset();

    this.agregarForm.get('proveedor')?.disable({onlySelf: true});
    this.agregarForm.get('autoriza').setValue(0);
    this.agregarForm.get('material')?.disable({onlySelf: true});

    this.agregarForm.get('horaAuth').setValue(formatDate(new Date(), 'HH:mm', 'en'));
    this.agregarForm.get('horaAuth')?.disable({onlySelf: true});

    this.agregarForm.get('fechaAuth').setValue(formatDate(new Date(), 'dd-MM-yyyy', 'en'));
    this.agregarForm.get('fechaAuth')?.disable({onlySelf: true});

    this.agregarForm.get('usuarioCaptura')?.disable({onlySelf: true});
    this.agregarForm.get('fechaHoraCaptura')?.disable({onlySelf: true});

    this.agregarForm.get('tipo').setValue(0);
    this.agregarForm.get('usuarioAutoriza').setValue(this.userName);

    this.openModal();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNueva();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
